import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../Layout/Main/header/Header";
import Footer from "../../Layout/Main/footer/FooterTwo";
const Content = [
{
    subTitle: 'Packing',
    Content: 'We help you to pack your supplies in the securest possible ways so that they are safe and easy to move.',
    id: 1
},
{
    subTitle: 'Loading',
    Content: 'We safely load your belongings into our moving trucks to ensure that there is no damage caused to your belongings.',
    id: 2
},
{
    subTitle: 'Moving',
    Content: 'During the move, we ensure that your belongings are safe and secure until they arrive at the new destination.',
    id: 3
},
{
    subTitle: 'Unloading',
    Content: 'When arrived at the destination our experts will unload all your stuff from the trucks and will place them in your.',
    id: 4
},
{
    subTitle: 'Unpacking',
    Content: 'We will unpack all the boxes and will put your furniture at your desired places. Our job isn"t done until you"re settled in your new home. ',
    id: 5
},

];
class Tips extends Component{
    render(){
        let title = 'Long Distance Moving';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Long Distance Moving' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Long Distance Moving'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-8 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">The moving process can be daunting and overwhelming for you either you are moving to your first house or you are moving to your dream home. Every step of the moving process can be very stressful from packing up your things to moving them to the new location. Long-distance moving is even more stressful because all the time you are worried about the safety and security of your possessions when traveling to a long distance. So it’s always better to avail of the services of a trusted and reliable moving company when you are planning a long-distance move. </p>
                                            <p className="description text-left pt--10">With over 10 years of combined experience in helping families for long-distance moving, <a href="/">Moonline</a> know how to make your move effortless and how to ease your troubled mind. We handle all your personal belongings with extra care and ensure safe packing and transportation. Not only that we also help you set up your things in your new home.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Your Trusted Moving Partners</h3>
                                            <p className="description text-left pt--50">When you are moving long-distance then you need a company that you can trust. <a href="/">Moonline</a> will be there to assist on each and every step of your move to make you feel comfortable and relaxed. Unlike other companies, we don’t charge any hidden fee to our clients and our sole aim is to make your move secure and stress-free. We also deliver your belongings to your desired destination at the right time.  We set flat-rate prices and guaranteed delivery dates to make long-distance moving easier and affordable for you. </p>
                                            <p className="description text-left pt--10">With over 10 years of combined experience in helping families for long-distance moving, <a href="/">Moonline</a> know how to make your move effortless and how to ease your troubled mind. We handle all your personal belongings with extra care and ensure safe packing and transportation. Not only that we also help you set up your things in your new home.</p>
                                        
                                        </div>
                                        {Content.map((val,id) =>(
                                            <div className="row mt--30 text-left">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div className="about-us-list">
                                                        <h3 className="title" key={id}>{val.subTitle}</h3>
                                                        <p key={id}>{val.Content}</p>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                               <p>We handle local, and cross-country moves. Whether you want to move your home or you want to move your office, we got you covered. If you are worried about the moving cost then we have flexible packages and flex payment for you depending upon the size of your home and business. You can contact us right now to get a free estimate for your move.</p>
                                                 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;